import { Card } from "primereact/card";
import { useState } from "react";
import RenderDialogContent from "./Dialog";
import { Dialog } from "primereact/dialog";
const MediaSection = ({ filteredMedia }) => {
  const [selectedMediaContent, setSelectedMediaContent] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const handleMediaClick = (media) => {
    setSelectedMediaContent(media);
    setShowDialog(true);
  };

  const onHideDialog = () => {
    setShowDialog(false);
  };

  return (
    <>
      <div className="w-full py-1 md:flex-1 md:pl-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {filteredMedia.map((media) => (
          <Card
            key={media.id}
            className="card-no-top-padding cursor-pointer hover:shadow-lg transition-shadow"
            onClick={() => handleMediaClick(media)}
          >
            <div className="relative pb-4">
              <img
                src={media.thumbnailUrl}
                alt={media.title}
                className="w-full h-auto rounded object-cover"
              />
            </div>
            <div className="mt-1">
              <h3 className="text-lg font-bold mb-1 line-clamp-3">
                {media.title}
              </h3>
              <p className="text-lg text-[#f36548] font-bold line-clamp-1">
                {media.presenter}
              </p>
              <p className="text-sm text-gray-600 gap-3">{media.date}</p>
              {/* <p className="flex flex-wrap gap-1">
                              {media.tags?.map((tag_data) => (
                                <Tag
                                  key={tag_data}
                                  value={tag_data}
                                  severity={getTypeColor(tag_data)}
                                  rounded
                                />
                              ))}
                            </p> */}
            </div>
          </Card>
        ))}
      </div>
      <Dialog
        visible={showDialog}
        style={{ width: "90%", maxWidth: "800px" }}
        onHide={onHideDialog}
        header={selectedMediaContent?.title || ""}
        dismissableMask
      >
        {RenderDialogContent({ selectedMedia: selectedMediaContent })}
      </Dialog>
    </>
  );
};

export default MediaSection;
